import React from 'react'

const PhotoPickerSvg = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_352_4587)">
        <path
          d="M12.004 11C12.004 11.7956 11.688 12.5587 11.1253 13.1213C10.5627 13.6839 9.79968 14 9.00403 14C8.20838 14 7.44532 13.6839 6.88271 13.1213C6.3201 12.5587 6.00403 11.7956 6.00403 11C6.00403 10.2044 6.3201 9.44129 6.88271 8.87868C7.44532 8.31607 8.20838 8 9.00403 8C9.79968 8 10.5627 8.31607 11.1253 8.87868C11.688 9.44129 12.004 10.2044 12.004 11Z"
          fill="white"
          fillOpacity="0.91"
        />
        <path
          d="M4.00403 2C2.94316 2 1.92575 2.42143 1.1756 3.17157C0.425456 3.92172 0.00402832 4.93913 0.00402832 6V26C0.00402832 27.0609 0.425456 28.0783 1.1756 28.8284C1.92575 29.5786 2.94316 30 4.00403 30H28.004C29.0649 30 30.0823 29.5786 30.8325 28.8284C31.5826 28.0783 32.004 27.0609 32.004 26V6C32.004 4.93913 31.5826 3.92172 30.8325 3.17157C30.0823 2.42143 29.0649 2 28.004 2H4.00403ZM28.004 4C28.5345 4 29.0432 4.21071 29.4182 4.58579C29.7933 4.96086 30.004 5.46957 30.004 6V19L22.45 15.106C22.2625 15.012 22.0501 14.9795 21.843 15.0128C21.6359 15.0462 21.4446 15.1439 21.296 15.292L13.876 22.712L8.55603 19.168C8.36395 19.0401 8.13355 18.9826 7.9039 19.0052C7.67426 19.0278 7.45949 19.1291 7.29603 19.292L2.00403 24V6C2.00403 5.46957 2.21474 4.96086 2.58981 4.58579C2.96489 4.21071 3.4736 4 4.00403 4H28.004Z"
          fill="white"
          fillOpacity="0.91"
        />
      </g>
      <defs>
        <clipPath id="clip0_352_4587">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PhotoPickerSvg
